import Head from 'next/head';
import { createApolloClient } from '../../../graphql';

import { GET_ALL_GIFT_CARDS_QUERY } from '@graphql/queries/gift';
import { GET_SERVICEABLE_COUNTRIES_ONLY } from 'src/http/countryAlone';
import { snackbarInfo } from 'store/utils';
import GiftCardStepOne from '@containers/GiftCardStepOne';
import GiftLayout from '@components/gift-layout';
import { AppRoutes } from '@utils/appRoutes';

interface IGiftCardStepOnePage {
  getAllGiftCards: any;
}

const GiftCardStepOnePage = ({ getAllGiftCards }: IGiftCardStepOnePage) => {
  return (
    <>
      <Head>
        <title>Gift Card | The Cumin Club</title>
      </Head>
      <GiftCardStepOne getAllGiftCards={getAllGiftCards} countryCode="ind" />
    </>
  );
};

GiftCardStepOnePage.getLayout = (page: any, pageProps: any) => {
  return (
    <GiftLayout
      {...pageProps}
      countryCode="ind"
      routing={AppRoutes.GIFT_CARD_STEP_ONE}
    >
      {page}
    </GiftLayout>
  );
};

export default GiftCardStepOnePage;

export const getStaticProps = async () => {
  const apolloClient = createApolloClient();

  const fetchServiceableCountries = async () => {
    try {
      const res = await apolloClient.query({
        query: GET_SERVICEABLE_COUNTRIES_ONLY,
      });
      const { data } = res || {};
      const { getServiceableCountries } = data || {};
      return getServiceableCountries;
    } catch (error: any) {
      snackbarInfo({
        message: error?.message,
        type: 'error',
      });
      console.log(error);
      return { error };
    }
  };

  const fetchAllGiftCard = async () => {
    try {
      const res = await apolloClient.query({
        query: GET_ALL_GIFT_CARDS_QUERY,
        variables: {
          input: {
            countryCode: 'ind',
          },
        },
      });
      const { data } = res || {};
      const { getAllGiftcards } = data || {};
      return getAllGiftcards;
    } catch (error: any) {
      snackbarInfo({
        message: error?.message,
        type: 'error',
      });
      console.log(error);
      return { error };
    }
  };

  const getServiceableCountries = await fetchServiceableCountries();
  const getAllGiftCards = await fetchAllGiftCard();

  // Pass data to the page via props
  return {
    props: {
      getServiceableCountries,
      getAllGiftCards,
    },
  };
};
